import * as Sentry from "@sentry/browser";
import Card from "../components/Card";
import Col from "antd/lib/col";
import Divider from "antd/lib/divider";
import Drawer from "antd/lib/drawer";
import { FormInstance } from "antd/lib/form/hooks/useForm";
import Input from "antd/lib/input";
import message from "antd/lib/message";
import Button from "antd/lib/button/button";
import { Tag } from "antd";
import { ColumnType } from "antd/lib/table";
import Table from "antd/lib/table/Table";
import { AxiosResponse } from "axios";
import debounce from "lodash.debounce";
import queryString from "query-string";
import React, { Fragment, RefObject } from "react";
import { RouteComponentProps } from "react-router-dom";
import {
  APIError,
  Customer,
  FormFieldConfig,
  SelfServiceActivity,
  UssdAccount,
} from "../helpers/shared-interfaces";
import {
  injectKey,
  request,
  responseHandler,
  getStateColor,
  formatSnakeCase,
  showTotalPagination,
} from "../helpers/utilities";
import {
  GET_USSD_ACCOUNTS,
  RESET_USSD_ACCOUNT_PIN,
  UPDATE_USSD_ACCOUNT_PHONE,
  UPDATE_USSD_ACCOUNT_STATUS,
} from "../gql/ussd";
import { GET_CUSTOMER_SELF_ACTIVITIES_QUERY } from "../gql/customers";
import { LOG_SELF_SERVICE_ACTIVITIES } from "../gql/general";
import {
  EmptyUssdAccount,
  UssdAccountUI,
  selfServiceActivityColumns,
} from "../components/SelfServiceActivities";
import BaseForm from "../components/Form/BaseForm";
import ModalCreator from "../components/ModalCreator";
import { PageToolbar } from "../components/PageToolbar";
import { DEBOUNCE_TIME } from "../helpers/constants";
import { generateDisplayErrorMessage } from "../helpers/utilities";


const user = JSON.parse(localStorage.getItem("user") as string);

interface UssdFilterParams {
  page: number;
  q: string;
}

interface State {
  id: string;
  isLoading: boolean;
  ussds: UssdAccount[];
  ussdCount: number;
  filterBy: string;
  isFiltering: boolean;
  filteredUssd: UssdAccount[];
  page: number;
  pageSize: number;
  q: string;
  activeDrawerContent: string;
  showDrawer: boolean;
  ussdAccount: UssdAccount | undefined;
  showConfirmCreateModal: boolean;
  showConfirmUpdateModal: boolean;
  filteredSelfServiceActivities: SelfServiceActivity[];
  customer?: Customer;
  isSelfActivityFiltering: boolean;
}

export function UssdTableFactory(
  data: UssdAccount[],
  toggleDrawer: (id: string) => void,
  page?: number,
  pageSize?: number,
  count?: number,
  nextPage?: (page: number) => void,
  loading?: boolean,
): JSX.Element {
  const finalColumns = ColumnCreator();

  const tempData: UssdAccount[] = data?.map(
    (record: UssdAccount): UssdAccount => {
      return { ...record, id: record.id };
    },
  );
  return (
    <Table
      scroll={{ x: 500 }}
      columns={finalColumns}
      dataSource={tempData}
      loading={loading}
      onRow={(record) => ({
        onClick: () => {
          toggleDrawer(record.id);
        },
        style: { cursor: "pointer" },
      })}
      pagination={{
        current: page,
        defaultPageSize: pageSize,
        total: count,
        onChange: nextPage,
        showTotal: showTotalPagination,
      }}
    />
  );
}

export function ColumnCreator(): ColumnType<UssdAccount>[] {
  return [
    {
      title: "Petra ID",
      dataIndex: "id",
      key: "id",
      render(text: string, record: UssdAccount): JSX.Element {
        return <span>{record?.customer?.petraId}</span>;
      },
    },
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      render(text: string, record: UssdAccount): JSX.Element {
        return <span>{record.customer?.fullname}</span>;
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render(text: string, record: UssdAccount): JSX.Element {
        return <span>{record?.phone.number}</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render(text: string, record: UssdAccount): JSX.Element {
        return (
          <Tag
            color={getStateColor(record.accountStatus)}
            style={{ textTransform: "capitalize" }}
          >
            {formatSnakeCase(record?.accountStatus)}
          </Tag>
        );
      },
    },
    // {
    //   title: "View More",
    //   dataIndex: "view",
    //   key: "view",
    //   align: "center",
    //   render(text: string, record: UssdAccount): JSX.Element {
    //     return (
    //       <Button
    //         onClick={() => {
    //           toggleDrawer(record.id);
    //         }}
    //         style={{ border: "none", color: `#179aff` }}
    //       >
    //         <EyeOutlined />
    //       </Button>
    //     );
    //   },
    // },
  ];
}

export const UpdateUssdAccount = (props: {
  reference: RefObject<FormInstance>;
  changeNumberFormConfig: FormFieldConfig[];
  showConfirmUpdateModal: boolean;
  isLoading: boolean;
  updateUssdAccountPhone: () => Promise<void>;
  toggleShowConfirmUpdateModal: () => void;
  renderTriggerButton?: boolean;
}): JSX.Element => {
  return (
    <>
      {props.showConfirmUpdateModal &&
        ModalCreator({
          title: "Edit Phone Number",
          isLoading: props.isLoading,
          showModal: props.showConfirmUpdateModal,
          onOkay: props.updateUssdAccountPhone,
          toggleModal: props.toggleShowConfirmUpdateModal,
          showFooter: false,
          width: 460,
          inscription: (
            <>
              <BaseForm
                reference={props.reference}
                fieldsToHide={[]}
                layout="horizontal"
                fields={props.changeNumberFormConfig}
                style={{ marginTop: "16px", fontWeight: "bold" }}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "16px",
                }}
              >
                <Button
                  type="primary"
                  onClick={props.updateUssdAccountPhone}
                  className="base-button"
                  style={{ borderRadius: 0, height: "33px" }}
                >
                  Update
                </Button>
              </div>
            </>
          ),
        })}

      {props.renderTriggerButton !== false && (
        <Button
          type="primary"
          onClick={() => {
            props.toggleShowConfirmUpdateModal();
          }}
          className="base-button"
          style={{
            position: "relative",
            top: "10px",
            right: "5px",
            borderRadius: 0,
            height: "33px",
          }}
        >
          Update
        </Button>
      )}
    </>
  );
};

export default class Ussd extends React.Component<RouteComponentProps, State> {
  filterReference: RefObject<FormInstance>;
  reference: RefObject<FormInstance>;

  constructor(props: Readonly<RouteComponentProps>) {
    super(props);
    this.state = {
      id: "",
      q: "",
      isLoading: true,
      ussds: [],
      ussdCount: 0,
      filterBy: "",
      isFiltering: false,
      filteredUssd: [],
      page: 1,
      pageSize: 25,
      activeDrawerContent: "",
      showDrawer: false,
      ussdAccount: undefined,
      showConfirmCreateModal: false,
      showConfirmUpdateModal: false,
      filteredSelfServiceActivities: [],
      customer: undefined,
      isSelfActivityFiltering: false,
    };

    this.filterReference = React.createRef<FormInstance>();
    this.reference = React.createRef<FormInstance>();
    this.getAllRecords = this.getAllRecords.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  setRef = (ref: React.RefObject<FormInstance>): void => {
    this.filterReference = ref;
  };

  async nextPage(page: number): Promise<void> {
    this.setState({ page }, () => {
      this.getAllRecords();
    });
  }

  async componentDidMount(): Promise<void> {
    await this.mergeWithLocalState();
    this.getAllRecords();
  }

  extractQueryParamsFromUrl = (): UssdFilterParams => {
    const parsed = queryString.parse(window.location.search);
    return JSON.parse(JSON.stringify(parsed)) as UssdFilterParams;
  };

  mergeWithLocalState = async (): Promise<void> => {
    const parsed = this.extractQueryParamsFromUrl();
    let q = "";
    let page = 1;

    if (parsed.q) {
      q = parsed.q;
    }

    if (parsed.page) {
      page = parsed.page;
    }

    this.setState({
      q,
      page: page,
    });
  };

  syncBrowserQueryString = (): void => {
    const { page, q } = this.state;

    this.props.history.replace(`?page=${page || ""}&q=${q || ""}`);
  };

  async getAllRecords(): Promise<void> {
    const { page, q } = this.state;
    interface Response {
      data: {
        ussdAccountSearch: {
          results: UssdAccount[];
          count: number;
        };
      };
    }

    this.setState({ isLoading: true });
    try {
      const {
        data: { data },
      }: AxiosResponse<Response> = await request({
        query: GET_USSD_ACCOUNTS,
        variables: {
          page,
          q,
        },
      });
      this.setState({
        ussds: data.ussdAccountSearch.results,
        ussdCount: data.ussdAccountSearch.count,
      });
    } catch (error) {
      message.error(`Search Failed - ${generateDisplayErrorMessage(error)}`);
      Sentry.captureException(error);
    } finally {
      this.syncBrowserQueryString();
      this.setState({ isLoading: false });
    }
  }

  handleSearchInput = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    this.setState({ q: event.target.value, page: 1 });
    await this.triggerDelayedSearch();
  };

  triggerDelayedSearch = debounce(async (): Promise<void> => {
    return await this.getAllRecords();
  }, DEBOUNCE_TIME);

  toggleDrawer = (id: string): void => {
    const ussdAccountSelected = this.state.ussds.find((item) => item.id === id);
    this.setState(
      {
        showDrawer: !this.state.showDrawer,
        ussdAccount: ussdAccountSelected,
      },
      () => {
        this.getCustomerSelfServiceActivities(
          this.state.ussdAccount?.customer?.id,
        );
      },
    );
  };

  closeDrawer = (): void => {
    this.setState({
      showDrawer: false,
      showConfirmUpdateModal: false,
    });
  };

  getCustomerSelfServiceActivities = async (
    customerId: string | undefined,
  ): Promise<void> => {
    this.setState({ isLoading: true });
    try {
      const {
        data,
      }: AxiosResponse<{
        data: {
          customer: Customer;
        };
      }> = await request({
        query: GET_CUSTOMER_SELF_ACTIVITIES_QUERY,
        variables: { customerId },
      });
      this.setState({
        customer: {
          ...this.state.customer,
          ...data.data.customer,
        } as Customer,
      });
    } catch (error) {
      // Fail silently or handle error
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  logSelfServiceActivity = async (
    description: string,
    channel: string,
    category: string,
    subCategory: string,
  ): Promise<void> => {
    interface Response {
      ussdAccount: UssdAccount;
      errors: APIError[];
    }
    this.setState({ isLoading: true });

    const customer = this.state.customer as Customer;
    const selfActivities = this.state.customer?.selfServiceActivities;

    try {
      const response: AxiosResponse<Response> = await request({
        query: LOG_SELF_SERVICE_ACTIVITIES,
        variables: {
          petraId: this.state?.ussdAccount?.customer?.petraId,
          description,
          channel,
          category,
          subCategory,
        },
      });
      const { err, mutation } = responseHandler<Response>(
        response,
        "logSelfServiceActivity",
      );

      if (err) {
        this.setState({ isLoading: false });
        message.error(`Failed to log activity - ${generateDisplayErrorMessage(err)}`);
      } else {
        this.setState({
          customer: {
            ...customer,
            ussdAccount: mutation.ussdAccount,
            selfServiceActivities: selfActivities,
          },
          isLoading: false,
        });
      }
    } catch (error) {}
  };

  changeUssdAccountStatus = async (
    id: string,
    accountStatus: number,
  ): Promise<void> => {
    interface Response {
      ussdAccount: UssdAccount;
      errors: APIError[];
    }

    const mapStatusToType: Record<number, string> = {
      0: "deactivate",
      1: "enable",
      2: "block",
    };

    const statusText = mapStatusToType[accountStatus];
    this.setState({ isLoading: true });

    try {
      const response: AxiosResponse<Response> = await request({
        query: UPDATE_USSD_ACCOUNT_STATUS,
        variables: { id, accountStatus },
      });

      const { err, mutation } = responseHandler<Response>(
        response,
        "updateUssdAccount",
      );

      if (err) {
        this.setState({ isLoading: false });
        message.error(`Failed to ${statusText} ussd account`);
      }

      if (mutation.ussdAccount) {
        this.setState(
          {
            ussdAccount: { ...this.state.ussdAccount, ...mutation.ussdAccount },
            isLoading: false,
          },
          () => {
            message.success(
              `Successfully ${statusText}${
                statusText === "block" ? "ed" : "d"
              } ussd account`,
            );
            this.logSelfServiceActivity(
              `Account ${statusText}${statusText === "block" ? "ed" : "d"} by ${
                user.name
              }`,
              "Ussd",
              "My Account",
              "Account Status",
            );
            this.getCustomerSelfServiceActivities(
              this.state.ussdAccount?.customer?.id,
            );
          },
        );
      }
    } catch (error) {}
  };

  resetUssdAccountPin = async (id: string): Promise<void> => {
    const { ussdAccount } = this.state;
    interface Response {
      ussdAccount: UssdAccount;
      errors: APIError[];
    }
    this.setState({ isLoading: true });

    try {
      const response: AxiosResponse<Response> = await request({
        query: RESET_USSD_ACCOUNT_PIN,
        variables: { id },
      });

      const { err, mutation } = responseHandler<Response>(
        response,
        "resetUssdAccountPin",
      );

      if (err) {
        message.error(`Failed to reset ussd account pin - ${generateDisplayErrorMessage(err)}`);
      } else {
        this.setState(
          {
            ussdAccount: { ...mutation.ussdAccount, ...this.state.ussdAccount },
          },
          () => {
            this.logSelfServiceActivity(
              `Account reset by ${user.name}`,
              "Ussd",
              "My Account",
              "PIN Reset",
            );
            this.getCustomerSelfServiceActivities(ussdAccount?.customer?.id);
          },
        );
        message.success("Successfully reset ussd account pin");
      }
    } catch (error) {
      message.error(`Something happened. Could not reset pin - ${generateDisplayErrorMessage(error)}`);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateUssdAccountPhone = async (): Promise<void> => {
    interface Response {
      ussdAccount: UssdAccount;
      errors: APIError[];
    }
    this.setState({ isLoading: true });

    if (!this.reference.current) {
      this.setState({ isLoading: false });
      return;
    }

    try {
      const data = await this.reference.current.validateFields(["phone"]);

      if (data.phone) {
        const response: AxiosResponse<Response> = await request({
          query: UPDATE_USSD_ACCOUNT_PHONE,
          variables: {
            ussdAccountId: this?.state?.ussdAccount?.id,
            phoneNumber: data?.phone,
          },
        });

        const { err, mutation } = responseHandler<Response>(
          response,
          "updateUssdAccountPhone",
        );

        if (err) {
          const notCustomerNumber = err.find(
            (item) => item.property === "phone_number",
          );
          if (notCustomerNumber) {
            message.error("This number is not associated with the customer");
          } else {
            message.error("Failed to update ussd account phone number");
          }
          this.logSelfServiceActivity(
            `Failed to update account number by ${user.name}`,
            "Ussd",
            "My Account",
            "Account number",
          );
          this.getCustomerSelfServiceActivities(
            this.state.ussdAccount?.customer?.id,
          );
        }

        if (mutation.ussdAccount) {
          this.setState(
            {
              ussdAccount: mutation.ussdAccount,
            },
            () => {
              this.logSelfServiceActivity(
                `Account number updated by ${user.name}`,
                "Ussd",
                "My Account",
                "Account number",
              );
              this.getCustomerSelfServiceActivities(
                this.state.ussdAccount?.customer?.id,
              );
            },
          );
          message.success("Successfully updated ussd account phone number");
        }
      }
    } catch (error) {
      message.error(`Failed to update ussd account phone number! - ${generateDisplayErrorMessage(error)}`);
      this.logSelfServiceActivity(
        `Failed to update account number by ${user.name}`,
        "Ussd",
        "My Account",
        "Account number",
      );
      this.getCustomerSelfServiceActivities(
        this.state.ussdAccount?.customer?.id,
      );
    } finally {
      this.setState({ isLoading: false, showConfirmUpdateModal: false });
      this.getAllRecords();
    }
  };

  toggleShowConfirmUpdateModal = (): void => {
    this.setState(
      {
        showConfirmUpdateModal: !this.state.showConfirmUpdateModal,
      },
      () => {
        if (this.state.showConfirmUpdateModal && this.reference.current) {
          this.reference.current.setFieldsValue({
            phone: this.state.ussdAccount?.phone?.number,
          });
        }
      },
    );
  };

  filterSelfServiceActivities = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    e.persist();
    const input = e.target.value;
    const activities = this.state.customer?.selfServiceActivities || [];
    const filteredData = activities.filter((activity) => {
      return (
        activity.channel.includes(input) ||
        activity.description.includes(input) ||
        activity.category?.includes(input) ||
        activity.subCategory?.includes(input) ||
        activity.updatedAt.includes(input)
      );
    });
    this.setState({
      isSelfActivityFiltering: true,
      filteredSelfServiceActivities: filteredData,
    });
  };

  render(): JSX.Element | null {
    const {
      isLoading,
      q,
      ussds,
      ussdCount,
      filteredUssd,
      isFiltering,
      page,
      pageSize,
      showDrawer,
      ussdAccount,
    } = this.state;

    const changeNumberFormConfig: FormFieldConfig[] = [
      {
        id: "phone",
        name: "phone",
        inputType: "phone",
        rule: "string",
        label: "Change Phone Number",
        placeholder: "Enter phone number",
        initialValue: ussdAccount?.phone?.number,
        required: false,
        colConfig: {
          span: 24,
        },
      },
    ];

    const selfServiceActivities = this.state.isSelfActivityFiltering
      ? this.state.filteredSelfServiceActivities
      : this.state.customer?.selfServiceActivities || [];

    return (
      <React.Fragment>
        <Card>
          <div className="ussd-table-container">
            <PageToolbar
              searchPlaceholder="Search by PetraID or Phone Number"
              searchValue={q}
              onSearchChange={this.handleSearchInput}
              totalCount={ussdCount}
              currentDataCount={
                isFiltering ? filteredUssd.length : ussds.length
              }
              page={page}
              pageSize={pageSize}
              modelName="ussd accounts"
            />
            {isFiltering
              ? UssdTableFactory(
                  filteredUssd,
                  this.toggleDrawer,
                  page,
                  pageSize,
                  ussdCount,
                  this.nextPage,
                  isLoading,
                )
              : UssdTableFactory(
                  ussds,
                  this.toggleDrawer,
                  page,
                  pageSize,
                  ussdCount,
                  this.nextPage,
                  isLoading,
                )}
          </div>
          <Drawer
            title={"Ussd Account"}
            width={1200}
            onClose={this.closeDrawer}
            visible={showDrawer}
            bodyStyle={{ paddingBottom: 80 }}
          >
            <Fragment>
              <div>
                <Col>
                  {ussdAccount ? (
                    <UssdAccountUI
                      ussdAccount={ussdAccount}
                      changeUssdAccountStatus={this.changeUssdAccountStatus}
                      resetUssdAccountPin={this.resetUssdAccountPin}
                      isLoading={isLoading}
                      inlineDetails
                      buttonsPosition="top"
                      extraActions={
                        <Button
                          id="edit-account-button"
                          type="primary"
                          className="base-button"
                          style={{ borderRadius: 0, height: "33px" }}
                          onClick={this.toggleShowConfirmUpdateModal}
                        >
                          Edit Number
                        </Button>
                      }
                    />
                  ) : (
                    <EmptyUssdAccount inlineDetails />
                  )}
                  <UpdateUssdAccount
                    reference={this.reference}
                    changeNumberFormConfig={changeNumberFormConfig}
                    showConfirmUpdateModal={this.state.showConfirmUpdateModal}
                    isLoading={this.state.isLoading}
                    updateUssdAccountPhone={this.updateUssdAccountPhone}
                    toggleShowConfirmUpdateModal={
                      this.toggleShowConfirmUpdateModal
                    }
                    renderTriggerButton={false}
                  />
                </Col>
              </div>
            </Fragment>

            <Divider />

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <h1>Customer Activities</h1>
              <Input.Search
                size="middle"
                type="text"
                placeholder="Filter by Channel, Description, Date or Sub-Category"
                onChange={this.filterSelfServiceActivities}
              />
            </div>

            <Table
              scroll={{ x: 500 }}
              style={{ width: "100%" }}
              columns={selfServiceActivityColumns}
              dataSource={injectKey<SelfServiceActivity>(
                selfServiceActivities,
                "id",
              )}
            />
          </Drawer>
        </Card>
      </React.Fragment>
    );
  }
}
